var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95627 14.75H19.9038C20.4838 14.75 20.9539 14.4142 20.9539 14C20.9539 13.5858 20.4838 13.25 19.9038 13.25H9.95627C9.37636 13.25 8.90625 13.5858 8.90625 14C8.90625 14.4142 9.37636 14.75 9.95627 14.75Z",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.995238 14.75H4.76667C5.31632 14.75 5.7619 14.4142 5.7619 14C5.7619 13.5858 5.31632 13.25 4.76667 13.25H0.995238C0.445583 13.25 0 13.5858 0 14C0 14.4142 0.445583 14.75 0.995238 14.75Z",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19141 14C4.19141 15.6569 5.59851 17 7.33426 17C9.07002 17 10.4771 15.6569 10.4771 14C10.4771 12.3431 9.07002 11 7.33426 11C5.59851 11 4.19141 12.3431 4.19141 14ZM8.90555 14C8.90555 14.8284 8.202 15.5 7.33412 15.5C6.46625 15.5 5.7627 14.8284 5.7627 14C5.7627 13.1716 6.46625 12.5 7.33412 12.5C8.202 12.5 8.90555 13.1716 8.90555 14Z",
    fill: "#8B8B8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0828 7.68555L1.13522 7.68555C0.555305 7.68555 0.0851946 8.02133 0.0851946 8.43555C0.0851946 8.84976 0.555305 9.18555 1.13522 9.18555L11.0828 9.18555C11.6627 9.18555 12.1328 8.84976 12.1328 8.43555C12.1328 8.02133 11.6627 7.68555 11.0828 7.68555Z",
    fill: "#8B8B8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0399 7.68555L16.2685 7.68555C15.7188 7.68555 15.2733 8.02133 15.2733 8.43555C15.2733 8.84976 15.7188 9.18555 16.2685 9.18555H20.0399C20.5896 9.18555 21.0352 8.84976 21.0352 8.43555C21.0352 8.02133 20.5896 7.68555 20.0399 7.68555Z",
    fill: "#8B8B8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8438 8.43555C16.8438 6.77869 15.4366 5.43555 13.7009 5.43555C11.9651 5.43555 10.558 6.77869 10.558 8.43555C10.558 10.0924 11.9651 11.4355 13.7009 11.4355C15.4366 11.4355 16.8438 10.0924 16.8438 8.43555ZM12.1296 8.43555C12.1296 7.60712 12.8332 6.93555 13.701 6.93555C14.5689 6.93555 15.2725 7.60712 15.2725 8.43555C15.2725 9.26397 14.5689 9.93555 13.701 9.93555C12.8332 9.93555 12.1296 9.26397 12.1296 8.43555Z",
    fill: "#8B8B8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95627 3.75H19.9038C20.4838 3.75 20.9539 3.41421 20.9539 3C20.9539 2.58579 20.4838 2.25 19.9038 2.25H9.95627C9.37636 2.25 8.90625 2.58579 8.90625 3C8.90625 3.41421 9.37636 3.75 9.95627 3.75Z",
    fill: "#8B8B8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.995238 3.75H4.76667C5.31632 3.75 5.7619 3.41421 5.7619 3C5.7619 2.58579 5.31632 2.25 4.76667 2.25H0.995238C0.445583 2.25 0 2.58579 0 3C0 3.41421 0.445583 3.75 0.995238 3.75Z",
    fill: "#8B8B8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19141 3C4.19141 4.65685 5.59851 6 7.33426 6C9.07002 6 10.4771 4.65685 10.4771 3C10.4771 1.34315 9.07002 0 7.33426 0C5.59851 0 4.19141 1.34315 4.19141 3ZM8.90555 3C8.90555 3.82843 8.202 4.5 7.33412 4.5C6.46625 4.5 5.7627 3.82843 5.7627 3C5.7627 2.17157 6.46625 1.5 7.33412 1.5C8.202 1.5 8.90555 2.17157 8.90555 3Z",
    fill: "#8B8B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/IconFilter.cf430a511d6468a79ad45b3922a04e90.svg";
export { ForwardRef as ReactComponent };